import { Avatar, AvatarFallback, AvatarImage } from '@/components/avatar'
import { Input } from '@/components/input'
import { Label } from '@/components/label'

import { useIdentity } from '@/state/identity'

import EmailAddress from './emailAddress'

export default function ProfileInfoCard() {
    const { identity } = useIdentity()

    if (!identity) {
        return null
    }

    return (
        <div className="flex items-center">
            <Avatar className="self-start w-16 h-16 mt-2 mr-4 uppercase">
                <AvatarImage src="/avatars/01.png" alt="@shadcn" />
                <AvatarFallback>{identity.identifier[0]}</AvatarFallback>
            </Avatar>
            <div className="flex-grow space-y-4">
                <div>
                    <Label>Name</Label>
                    <Input className="w-full" value={identity.name} />
                </div>
                <EmailAddress identity={identity} />
            </div>
        </div>
    )
}
